import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import b from 'b_';
import cn from 'classnames';
import FuseButton from '../FuseControls/FuseButton';
import { FTTitle } from '../Fuse';
import './FuseBrowserModal.css';

const block = b.lock('FuseBrowserModal');

const FuseBrowserModal = ({
    children,
    onClose,
    onBack,
    title,
    subTitle,
    className,
    headerClassName,
    contentClassName,
    positionCenter,
    hideCloseButton,
    hideBackButton = false,
    hideFooter = false,
    large,
    small,
    overlayClassName,
    footerActions,
    ...otherProps
}) => (
    <ReactModal
        className={cn(block({ positionCenter, large, small }), className)}
        overlayClassName={cn(block('Overlay'), overlayClassName)}
        ariaHideApp={false}
        onRequestClose={onClose}
        closeTimeoutMS={200}
        {...otherProps}
    >
        <div className={cn(block('Header'), headerClassName)}>
            {hideBackButton ? null
                : (
                    <FuseButton
                        className={block('Back')}
                        icon="arrow_back"
                        color="black"
                        onClick={onBack}
                        qa="modal_back"
                    />
                )}
            <FTTitle className={block('Title')} title={`${title}${subTitle || ''}`}>
                {title}
                {subTitle ? <FTTitle className={block('SubTitle')}>{subTitle}</FTTitle> : null}
            </FTTitle>
            {hideCloseButton ? null
                : (
                    <FuseButton
                        className={block('Close')}
                        icon="close"
                        color="black"
                        onClick={onClose}
                        qa="modal_close"
                    />
                )}
        </div>
        <div className={block('ContentWrapper', { hideFooter })}>
            <div className={cn(block('Content'), contentClassName)}>
                {children}
            </div>
        </div>
        {!hideFooter && (
            <div className={block('Footer')}>
                {footerActions}
            </div>
        )}
    </ReactModal>
);

FuseBrowserModal.propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
    onBack: PropTypes.func,
    title: PropTypes.node.isRequired,
    subTitle: PropTypes.node,
    className: PropTypes.string,
    headerClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    positionCenter: PropTypes.bool,
    hideCloseButton: PropTypes.bool,
    hideBackButton: PropTypes.bool,
    hideFooter: PropTypes.bool,
    large: PropTypes.bool,
    small: PropTypes.bool,
    overlayClassName: PropTypes.string,
    footerActions: PropTypes.node,
    isOpen: PropTypes.bool.isRequired,
    style: PropTypes.shape({
        content: PropTypes.object,
        overlay: PropTypes.object,
    }),
    closeTitle: PropTypes.string,
};

export default FuseBrowserModal;
